// import React from "react";
import { connect } from "react-redux";
import ButtonComponent from "../../components/form-component/ButtonComponent";
import LayoutContainer from "../../screens/layout/admin-dashboard";
import Header from "../../screens/layout/components/Header";
import Footer from "../../screens/layout/components/Footer";
import React from "react";
import "../../static/css/styles.scss";

class SessionExpired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  render() {
    return (
      <div className="desktop">
        <Header
          username={this.props.userName}
          toggleNotifications=""
          toggleMenu={() => {}}
        />
        <section className={`main-section `}>
          <div className="row center">
            <div className="col-lg-12 text-center">
              <div className="permision-message">Session Expired!</div>
              <ButtonComponent
                type="submit"
                className="btn-danger mt-4"
                title="Login"
                onClick={() => {
                  console.log("close");
                  this.props.history.push("/");
                  // window.close();
                  // self.close();
                }}
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { userName: state.auth.userName };
}

export default connect(mapStateToProps)(SessionExpired);
